import styled from "styled-components";
import { getBreakpoints } from "../../assets/store/cssBreakpoints";
const { xs, sm, md, lg, xl, xxl } = getBreakpoints();

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: black;
    background-color: ${(props) =>
        props.bgColor ? props.bgColor : "transparent"};
    width: ${(props) => (props.margin ? `unset` : "100%")};
    font-family: ${(props) =>
        props.defaultFontFamily ? props.defaultFontFamily : "inherit"};
    padding: ${(props) => {
        if (props.isTableRow) return "2rem 0";
        if (props.padding) return props.padding;
        return "unset";
    }};
    margin: ${(props) => (props.margin ? props.margin : "unset")};
    box-sizing: ${(props) => (props.padding ? "border-box" : "unset")};
`;

export const StyledContentWrapper = styled.div`
    width: 100%;
    display: flex;
    max-width: 1400px;
    margin: 10px auto;
    height: fit-content;
`;

export const AmenitiesWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    @media screen and (max-width: ${xl}px) {
        :first-of-type {
            margin-bottom: 50px;
        }
    }
`;

export const Title = styled.h1`
    &&&&& {
        font-size: 2rem;
        font-weight: 900;
        font-family: inherit;
        margin: 20px 0;
        color: ${(props) => (props.textColor ? props.textColor : "black")};
        letter-spacing: ${(props) => props.letterSpacing ?? 'unset'};
        text-transform: ${(props) => props.textTransform ?? 'none'};
    }
`;

export const SubTitle = styled.h2`
    &&&&& {
        font-size: 1.5rem;
        font-weight: 900;
        font-family: inherit;
        margin: 20px 0 0 0;
        color: ${(props) => (props.textColor ? props.textColor : "black")};
        text-align: center;
        letter-spacing: ${(props) => props.letterSpacing ?? 'unset'};
        text-transform: ${(props) => props.textTransform ?? 'none'};
    }

    @media screen and (max-width: ${xl}px) {
        font-size: 1rem;
    }
`;

export const BodyText = styled.p`
    text-align: ${(props) =>
        !props.textAlign || props.textAlign === "default"
            ? "center"
            : props.textAlign};
    line-height: ${(props) => props.lineHeight ?? 1.5};
    letter-spacing: ${(props) => props.letterSpacing ?? 'unset'};
    font-family: inherit;
    font-size: inherit;
    width: 60%;
    margin: 20px;
    color: ${(props) => (props.textColor ? props.textColor : "black")};

    @media screen and (max-width: ${xl}px) {
        font-size: unset;
    }
`;

export const StyledDivider = styled.hr`
    width: 40%;
    height: 1px;
    background-color: black;
    margin: 0;
    padding: 0;
`;

export const StyledButton = styled.button`
    &&&&& {
        display: flex;
        justify-content: center;
        align-items: center;
        background: ${(props) => props.bgColor ?? "#e82738"};
        color: ${(props) => props.color ?? "white"};
        height: 66px;
        border-radius: ${(props) => props.borderRadius ?? '100px'};
        border: ${(props) => props.borderColor ? `2px ${props.borderColor} solid` : 'none'};
        outline: none;
        padding: ${(props) =>
            props.isIconVisible ? "0.50rem 1.25rem" : "0.75rem 2.25rem"};
        gap: 10px;
        font-family: inherit;
        cursor: pointer;
        transition: 0.25s;
        font-family: inherit;
        font-weight: bold;
        font-size: 16px;
        height: 56px;
        min-width: 218px;
        fill: ${(props) => props.color ?? "white"};
        margin-top: 12px !important;
        margin-bottom: 12px !important;
        letter-spacing: ${(props) => props.letterSpacing ?? 'unset'};
        text-transform: ${(props) => props.textTransform ?? 'unset'};
    }

    &:hover {
        background: ${(props) => props.hoverBgColor ?? "#ba202c"};
        color: ${(props) => props.hoverColor ?? "white"};
        box-shadow: 0 0.5em 0.5em -0.4em transparent;
        transform: translateY(-0.25em);
        fill: ${(props) => props.hoverColor ?? "white"};
    }

    @media screen and (max-width: ${sm}px) {
        font-size: 12px;
        min-width: 199px;
        height: 44px;
        margin: 30px 10px;
        gap: 7px;
        font-size: 12px;
        height: 44px;
        min-width: 199px;
    }
`;

export const AmenityContainer = styled.div`
    display: grid;
    grid-template-columns: ${(props) =>
        props.isSingleColumn ? "1fr" : "1fr 1fr"};
    column-gap: 5vw;
    justify-items: center;
    margin: 0 50px;
    font-size: inherit;
`;
